/**
 * Strip HTML tags and decode entities, returning plain text.
 * Useful for showing HTML content as a preview in table cells.
 */
export const stripHtml = (html) => {
  if (!html) return ''
  const tempDiv = document.createElement('div')
  tempDiv.innerHTML = html
  return tempDiv.textContent || tempDiv.innerText || ''
}
